<script>
  import { createEventDispatcher } from "svelte";
  import { Icon, EyeSlash, Eye } from "svelte-hero-icons";

  export let element;
  export let showInOverlay = false;

  const dispatch = createEventDispatcher();

  function toggleActive() {
    showInOverlay = !showInOverlay;
    dispatch("toggle", { id: element.ui_id, active: showInOverlay });
  }
</script>

<button
  class="flex items-center justify-between w-full p-1 hover:bg-surface-hover rounded text-xs"
  on:click={toggleActive}
>
  <div class="flex items-center space-x-2 text-left">
    <Icon
      src={showInOverlay ? Eye : EyeSlash}
      mini
      class="w-4 h-4 {showInOverlay ? 'text-blue-500' : 'text-content-subtle'}"
    />
    <span>{element.name}</span>
  </div>
  {#if element.executionTime}
    <span class="text-content-subtle">{element.executionTime}ms</span>
  {/if}
</button>
